import { baseSliceWithTags } from '../baseSlice';
import { authHeader } from '../../constants/authenticationHeader';

const clientOwnershipApi = baseSliceWithTags.injectEndpoints({
    endpoints: (builder) => ({
        claimClient: builder.mutation({
            query: (clientId) => ({
                url: `/rest/client-ownership/claim/${clientId}`,
                method: 'post',
                csrf: authHeader(),
            }),
        }),
        approveClaim: builder.mutation({
            query: ({ clientId, owner_account_id }) => ({
                url: `/rest/client-ownership/approve-claim/${clientId}`,
                method: 'post',
                data: { owner_account_id },
                csrf: authHeader(),
            }),
        }),
        rejectClaim: builder.mutation({
            query: (clientId) => ({
                url: `/rest/client-ownership/reject-claim/${clientId}`,
                method: 'post',
                csrf: authHeader(),
            }),
        }),
        mergeClients: builder.mutation({
            query: ({ sourceId, targetId }) => ({
                url: `/rest/client-ownership/merge/${sourceId}/into/${targetId}`,
                method: 'post',
                csrf: authHeader(),
            }),
        }),
        reassignClient: builder.mutation({
            query: ({ clientId, owner_account_id }) => ({
                url: `/rest/client-ownership/reassign/${clientId}`,
                method: 'post',
                data: { owner_account_id },
                csrf: authHeader(),
            }),
        }),
        getAuditTrail: builder.query({
            query: (clientId) => ({
                url: `/rest/client-ownership/audit/${clientId}`,
                method: 'get',
                csrf: authHeader(),
            }),
        }),
        getClaimStatus: builder.query({
            query: (clientId) => ({
                url: `/rest/client-ownership/status/${clientId}`,
                method: 'get',
                csrf: authHeader(),
            }),
        }),
        getPendingClaims: builder.query({
            query: () => ({
                url: '/rest/client-ownership/pending-claims',
                method: 'get',
                csrf: authHeader(),
            }),
        }),
        discoverClients: builder.query({
            query: (params) => ({
                url: '/rest/client-ownership/discover',
                method: 'get',
                csrf: authHeader(),
                params,
            }),
        }),
    }),
    overrideExisting: true,
});

export const {
    useClaimClientMutation,
    useApproveClaimMutation,
    useRejectClaimMutation,
    useMergeClientsMutation,
    useReassignClientMutation,
    useGetAuditTrailQuery,
    useGetClaimStatusQuery,
    useGetPendingClaimsQuery,
    useDiscoverClientsQuery,
} = clientOwnershipApi;
